/**
 * Language registry — the single list of interface languages (§15.1, multi-
 * language increment 1, owner-approved 2026-07-27).
 *
 * The app is language-blind: adding a language here + a dictionary file at
 * `src/locales/<code>.json` makes it appear in every language picker. No
 * other code changes. Codes are BCP-47 (match `users.locale`, max 10 chars).
 *
 * Dictionaries use NATURAL KEYS (gettext style): the key IS the English
 * source string, so English needs no dictionary and a missing translation
 * falls back to the English text — a partial dictionary can never blank a
 * screen. Generate/refresh a dictionary with `pnpm translate <code>`.
 */
export const LANGUAGES = [
    { code: 'en', nativeName: 'English', dir: 'ltr' },
    { code: 'zh-CN', nativeName: '中文（简体）', dir: 'ltr' },
];
export const DEFAULT_LANGUAGE = 'en';
export function isSupportedLanguage(code) {
    return !!code && LANGUAGES.some((l) => l.code === code);
}
